import request from '@/utils/request'

// 查询问卷配置列表
export function listSurvey(query) {
    return request({
        url: '/biz/survey/list',
        method: 'get',
        params: query
    })
}

// 查询问卷配置详细
export function getSurvey(id) {
    return request({
        url: '/biz/survey/' + id,
        method: 'get'
    })
}

// 新增问卷配置
export function addSurvey(data) {
    return request({
        url: '/biz/survey',
        method: 'post',
        data: data
    })
}

// 修改问卷配置
export function updateSurvey(data) {
    return request({
        url: '/biz/survey/update',
        method: 'post',
        data: data
    })
}

// 删除问卷配置
export function delSurvey(id) {
    return request({
        url: '/biz/survey/delete/' + id,
        method: 'post'
    })
}
